import { consoleEvents } from '@pb/utils'

import { updateFetchedPostalCode } from 'features/checkout/duck/actions'
import { fetchPostalCode } from 'features/checkout/requests'
import { ThunkResult } from 'redux/types'

export const operationFetchPostalCode =
  (district): ThunkResult<void> =>
  async (dispatch) => {
    try {
      const postalCode = await fetchPostalCode(district)
      dispatch(updateFetchedPostalCode(postalCode))
    } catch (error) {
      consoleEvents.error('Could not get Postal Code', error)
    }
  }
